import React from "react";
import {
  SkeletonElement,
  SkeletonSugestedCom,
  Shimmer,
  SkeletonEcobookCard,
} from "..";

const EcoBookSkeletonLoader: React.FC = () => {
  return (
    <div className="flex justify-between pt-12 pb-5 mx-auto w-[90%]">
      <div className="w-[25%] flex flex-col h-fit bg-white pt-1 pb-2 pl-1">
        <div className="mb-3 ml-1">
          <SkeletonElement type="title" />
        </div>
        {[1, 2, 3].map((n) => (
          <SkeletonSugestedCom key={n} />
        ))}
      </div>
      <div className="flex-1 flex flex-col items-center gap-5 justify-between w-[60%]">
        <div className="w-full flex flex-col items-center gap-5 justify-between relative overflow-hidden">
          <div className="w-[55%] px-5 flex justify-center">
            <div className="bg-white rounded w-full shadow-sm flex h-10 items-center pl-10">
              <div className="flex-1 ">
                <SkeletonElement type="title" />
              </div>
              <div className="flex-1 ">
                <SkeletonElement type="title" />
              </div>
            </div>
          </div>
          <div className=" ml-[92px] w-[105%]">
            <SkeletonElement type="image" />
          </div>
          <Shimmer />
        </div>
        <div className="grid grid-cols-4 gap-4 w-[95%] overflow-hidden">
          {[1, 2, 3, 4].map((n) => (
            <SkeletonEcobookCard key={n} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EcoBookSkeletonLoader;
